import type { Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

export type CodeSelection = {
  id: string;
  filePath: string;
  from: number;
  to: number;
  fromLine: number;
  toLine: number;
  fromChar: number;
  toChar: number;
  text: string;
  revision?: "current" | "previous";
};

export function selectionExtension(
  filePath: string,
  onChange: (selections: CodeSelection[]) => void
): Extension {
  return EditorView.updateListener.of((update) => {
    if (!update.selectionSet) return;
    const { state } = update;
    const snippets: CodeSelection[] = [];
    for (const range of state.selection.ranges) {
      if (range.empty) continue;
      const fromLineData = state.doc.lineAt(range.from);
      const toLineData = state.doc.lineAt(range.to);
      const fromLine = fromLineData.number;
      const toLine = toLineData.number;
      const fromChar = range.from - fromLineData.from;
      const toChar = range.to - toLineData.from;
      const text = state.sliceDoc(range.from, range.to);
      snippets.push({
        id: `${filePath}:${fromLine}:${fromChar}-${toLine}:${toChar}`,
        filePath,
        from: range.from,
        to: range.to,
        fromLine,
        toLine,
        fromChar,
        toChar,
        text,
      });
    }
    onChange(snippets);
  });
}
